/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandKbin = createReactComponent("brand-kbin", "IconBrandKbin", [
  ["g", { key: "svg-0", strokeWidth: "1.838" }]
]);

export { IconBrandKbin as default };
//# sourceMappingURL=IconBrandKbin.js.map
